import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from '@mui/material'
import {
  Close as CloseIcon,
  ArrowForward as NextIcon,
} from '@mui/icons-material'

const CommonModal = ({
  open,
  onClose,
  title,
  children,
  maxWidth = 'sm',
  fullWidth = true,
  fullScreen = false, // Add fullScreen prop
  showCloseButton = true, // normal mode
  actions = null,
  sx = {},
  // multi-step props
  showNextButton = false,
  onNext,
  isLastStep = false,
  modalHeight = 'auto',
  isChecked = false,
  textColor='black'
}) => {
  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return
    onClose(event, reason)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={fullScreen ? false : maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: fullScreen ? '0px' : '8px',
          height: fullScreen ? '100vh' : modalHeight,
          ...sx,
        },
      }}
    >
      {/* Dialog Title */}
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px 24px',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontWeight: '500',
            fontSize: '20px',
            color: textColor,
          }}
        >
          {title}
        </Typography>

        {/* Normal mode: show close */}
        {!showNextButton && showCloseButton && (
          <IconButton
            onClick={onClose}
            sx={{ color: 'var(--forbrand-primary)' }}
          >
            <CloseIcon />
          </IconButton>
        )}

        {/* Multi-step last step: show close */}
        {showNextButton && isLastStep && (
          <IconButton
            onClick={onClose}
            sx={{ color: '#666', '&:hover': { backgroundColor: '#e3f2fd' } }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      {/* Dialog Content */}
      <DialogContent
        className="hide-scrollbar"
        sx={{
          padding: '24px',
          '&.MuiDialogContent-root': { paddingTop: '16px' },
        }}
      >
        {children}
      </DialogContent>

      {/* Dialog Actions */}
      {(actions || (showNextButton && !isLastStep)) && (
        <DialogActions
          sx={{
            borderTop: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            justifyContent: 'flex-end',
            px: 2,
          }}
        >
          {actions}
          <Button variant="outlined" color="error" onClick={onClose}>
            Cancel
          </Button>

          {showNextButton && !isLastStep && (
            <Box>
              <Button
                variant="contained"
                onClick={onNext}
                disabled={!isChecked}
                sx={{
                   bgcolor: 'var(--forbrand-bg-variant)',
                   color: 'var(--forbrand-brand-varient)',
                }}
              >
                I Agree
              </Button>
            </Box>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}

export default CommonModal
